"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const initialData_1 = __importDefault(require("./initialData"));
const schema_1 = __importDefault(require("./schema"));
const uiSchema_1 = __importDefault(require("./uiSchema"));
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const mapper_1 = require("./mapper");
const addDeleteDisciplineTemplate = {
    formToPayloadDataHandler: formToPayloadDataHandler_1.addDeleteDisciplineFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.addDeleteDisciplinePayloadToFormDataHandler,
    initialData: initialData_1.default,
    schema: schema_1.default,
    uiSchema: uiSchema_1.default,
    templateMapper: mapper_1.templateMapper,
};
exports.default = addDeleteDisciplineTemplate;
